import { render, staticRenderFns } from "./store-info.vue?vue&type=template&id=e204b3b2&scoped=true"
import script from "./store-info.vue?vue&type=script&lang=js"
export * from "./store-info.vue?vue&type=script&lang=js"
import style0 from "./store-info.vue?vue&type=style&index=0&id=e204b3b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e204b3b2",
  null
  
)

export default component.exports